import { Component, inject } from "@angular/core";
import { RdxProgressIndicatorDirective, RdxProgressRootDirective } from "@radix-ng/primitives/progress";
import { SequenceService } from "@services/sequence.service";

@Component({
  selector: "app-progress-bar",
  imports: [RdxProgressIndicatorDirective, RdxProgressRootDirective],
  template: `
    <div data-testid="progress-bar" class="progress-bar">
      @if (this.sequenceService.isInitialized) {
        @let currentExerciseNumber = sequenceService.currentExerciseNumber;
        @let currentSequenceLength = sequenceService.currentSequenceLength;

        @let progress = (100 * currentExerciseNumber) / currentSequenceLength;

        <div
          class="progress-bar__progress"
          [value]="progress"
          rdxProgressRoot
          [max]="currentSequenceLength"
          [value]="currentExerciseNumber"
          [valueLabel]="getValueLabel"
        >
          <div data-testid="progression" class="progress-bar__current-progress" [style.width]="progress + '%'" rdxProgressIndicator></div>
        </div>
        <div class="progress-bar__statistics">
          <p class="subtitle-3" data-testid="progression-statistics">
            <span class="desktop-only">Exercice </span>{{ currentExerciseNumber }}/{{ currentSequenceLength }}
          </p>
        </div>
      } @else {
        <p class="subtitle-3" rdxProgressRoot [valueLabel]="getProgressCalculatingValueLabel">Calcul en cours</p>
      }
    </div>
  `,
  styles: `
    @use "responsive" as *;

    .desktop-only {
      @include onDesktopOnly();
    }

    .progress-bar {
      display: flex;
      align-items: center;
      height: 56px;
      gap: 20px;
      padding: 0 32px;
      border-radius: 20px;
      background-color: #ffffff;
      border: 2px solid #e7e1d8;
      box-shadow: 0 4px 0 #e7e1d8;
      border-radius: 20px;
    }

    .progress-bar__progress {
      flex-shrink: 1;
      flex-grow: 1;
      height: 12px;
      border-radius: 20px;
      overflow: hidden;
      background-color: #e7e1d8;
    }

    .progress-bar__current-progress {
      height: 12px;
      border-radius: 20px;
      background-color: #d65100;
      transition: width 1s;
    }
  `,
})
export class ProgressBar {
  protected sequenceService = inject(SequenceService);

  getValueLabel = (value: number, max: number) => {
    return `Exercice ${value} de ${max}`;
  };

  getProgressCalculatingValueLabel = () => {
    return "Calcul du progrès en cours";
  };
}
